import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Form, Formik, FormikConfig } from "formik";
import { Button } from "components/atoms";
import { PiFloppyDisk, PiTrash } from "react-icons/pi";
import {
  useDeleteUserSpecification,
  useGetUserSpecifications,
} from "services/configuration/notifications";
import {
  INotificationSettingsForm,
  MockedNotificationsType,
  UserSpecificationsResponse,
} from "services/configuration/notifications/types";
import { BUTTON_VARIANT } from "types/components/button/button.interface";
import { II18nextPrefix } from "types/components/components.interface";
import { onErrorShowAllErrorsToast } from "utils/service/errorHandler";
import { IFormProps } from "../../types";
import NotificationContent from "./NotificationContent";

interface ISettingsForm
  extends FormikConfig<INotificationSettingsForm>,
    IFormProps,
    II18nextPrefix {}

const NotificationSettingsForm = ({
  i18nextPrefix,
  topbarContent,
  tittle,
  status,
  disableTabs,
  onSubmit,
  backPath,
  customBackItem,
  ...props
}: ISettingsForm) => {
  const { t } = useTranslation();

  const [showButtons, setShowButtons] = useState(false);

  return (
    <Formik
      {...props}
      validateOnChange
      validateOnBlur
      validateOnMount
      onSubmit={onSubmit}
      initialStatus={status}
      enableReinitialize
    >
      {({ submitForm }) => (
        <Form className="w-full h-full">
          <NotificationContent />
          <div className="buttons">
            <Button type="submit" variant={BUTTON_VARIANT.submit}>
              <Button.Icon icon={<PiFloppyDisk transform="scale(-1,1)" />} />
              <Button.Text text={t(`enum.TEMPLATE_TYPE_SETTINGS.submit`)} />
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default NotificationSettingsForm;
